<template>
	<el-row>
		<el-button @click="add">添加品类款式+</el-button>
		<el-row>
			<el-col>
				<span>分类名称</span>
				<el-cascader v-model="arr" :options="options2" :props="props" style="margin: 0 10px; width: 300px">
				</el-cascader>
				<span>商品id</span>
				<el-input v-model="commodityId" style="margin: 0 10px; width: 300px"></el-input>
				<span>商品名称</span>
				<el-input v-model="commodityName" style="margin: 0 10px; width: 300px"></el-input>
				<el-button @click="screen()" type="primary">筛选</el-button>
				<el-button @click="Export()">导出Excel</el-button>
				<el-button @click="reset()" type="success">重置</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="序号" width="50px" prop="id"></el-table-column>
					<el-table-column label="商品款式" prop="commodityName">
						<template slot-scope="scope">
							<el-image :src="scope.row.commodityPic" style="width: 100px;height: 100px;"></el-image>
							<div>{{scope.row.commodityName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="商品id" prop="commodityId"></el-table-column>
					<el-table-column label="一级分类" prop="primaryName"></el-table-column>
					<el-table-column label="二级分类" prop="secondaryName"></el-table-column>
					<el-table-column label="销售人群">
						<template slot-scope="scope">
							<span>{{scope.row.labelName.join(',')}}</span>
						</template>
					</el-table-column>
					<el-table-column label="成品素材">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'07')">成品素材</el-button>
						</template>
					</el-table-column>
					<el-table-column label="优秀圈文">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'08')">优秀圈文</el-button>
						</template>
					</el-table-column>
					<el-table-column label="用户反馈">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'09')">用户反馈</el-button>
						</template>
					</el-table-column>
					<el-table-column label="核心卖点">
						<template slot-scope="scope">
							<el-button type="text" @click="toView(scope.row.id,'10')">核心卖点</el-button>
						</template>
					</el-table-column>
					<el-table-column label="应用状态">
						<template slot-scope="scope">
							{{scope.row.state == 0 ?'上架':'下架'}}
						</template>
					</el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="isStatus(scope.row)" type="text">{{scope.row.state == 1 ?'上架':'下架'}}
							</el-button>
							<el-button @click="editorCircle(scope.row)" type="text">编辑</el-button>
							<el-button @click="viewCircle(scope.row)" type="text">查看</el-button>
							<el-button @click="delCircle(scope.row)" type="text">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto; width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30, 60, 100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :visible.sync="dialogVisible" :title="title" center width="30%">
			<el-form ref="info" :model="info" label-position="right" label-width="80px">
				<el-form-item label="分类" prop="arr" :rules="[{ 
					required: true, message: '请选择分类', trigger: 'change' }]">
					<el-cascader v-model="info.arr" :options="options2" :props="props" @change="visibleChange"
						style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="商品款式" prop="commodityId" :rules="[{ 
					required: true, message: '请选择商品款式', trigger: 'change' }]">
					<el-select v-model="info.commodityId" filterable placeholder="可选择可输入">
						<el-option :props="props" v-for="item in options" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<div style="color:burlywood;">请先选择分类，根据分类选择款式</div>
				</el-form-item>
				<el-form-item label="销售人群" prop="labelIds" :rules="[{
					  required: true,message: '请选择销售人群',trigger: 'change',}]">
					<el-cascader v-model="info.labelIds" :options="options3" :props="props2" clearable
						style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="应用状态" prop="state" :rules="[{
					  required: true,message: '请选择应用状态',trigger: 'change',}]">
					<el-radio-group v-model="info.state">
						<el-radio :label="0">上架</el-radio>
						<el-radio :label="1">下架</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				commodityId: '',
				commodityName: '',
				options: [], //商品数组
				options2: [], //分类数组
				options3: [], //销售人群
				props: {
					value: "id",
					label: "name",
					children: "sonList",
				},

				props2: {
					value: "id",
					label: "name",
					children: "sonList2",
					multiple: true
				},
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				arr: [],
				dialogVisible: false,
				title: "",
				arr: [],
				id: '',
				info: {
					id: '',
					arr: [],
					labelIds: [],
					primaryType: "",
					secondary: "",
					commodityId: "",
					labelIds: [],
					state: ''
				},
			}
		},
		methods: {
			visibleChange() {
				console.log(this.info.arr[1]);
				this.info.commodityId = ''
				if (this.info.arr.length > 0) {
					this.$http.get(
							`/api/product/productCategory/selectProductByCategoryId?categoryId=${this.info.arr[1]}`, {})
						.then(
							res => {
								// console.log(res);
								if (res.data.data.length > 0) {
									this.options = []
									res.data.data.forEach(item => {
										this.options.push({
											label: item.name,
											value: item.id
										})
									})
								}
							}
						)
				}
			},
			toView(id, num) {
				this.$router.push({
					path: '/catStyleDet',
					query: {
						id: id,
						kinds: num
					}
				})
			},
			isStatus(row) {
				console.log(row);
				this.$confirm('此操作将改变上下架, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/knowledgeBase/updateCategoryStyle', {
						"id": row.id,
						"state": row.state == 0 ? 1 : 0
					}).then(res => {
						console.log(res.data);
						this.getList()
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			add() {
				this.dialogVisible = true;
				this.title = "添加品类款式";
				this.info = {
					id: '',
					arr: [],
					primaryType: "",
					secondary: "",
					commodityId: "",
					labelIds: [],
					state: ''
				};
				this.options = []
			},
			screen() {
				this.getList()
			},
			Export() {
				let primaryType = null
				let secondary = null
				if (this.arr.length > 0) {
					primaryType = arr[0]
					secondary = arr[1]
				}
				this.$http.post('/api/statistics/knowledgeBase/exportCategoryStyle', {
					"id": null, //ID
					"primaryType": primaryType, //一级品类编号
					"secondary": secondary, //二级品类编号
					"salesCrowd": "", //销售人群
					"commodityId": "" //商品款式
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出品类款式表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '品类款式列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			reset() {
				this.arr = []
				this.commodityId = ''
				this.commodityName = ''
				this.getList()
			},
			submit() {
				console.log(this.info.labelIds);
				this.$refs.info.validate((vai) => {
					if (vai) {
						let labelIds = []
						if (this.info.arr.length > 0) {
							this.info.primaryType = this.info.arr[0]
							this.info.secondary = this.info.arr[1]
						}
						if (this.info.labelIds.length > 0) {
							this.info.labelIds.forEach(i => {
								labelIds.push(i[1])
							})
						}
						if (this.title == '添加品类款式') {
							this.$http.post('/api/plant/knowledgeBase/insertCategoryStyle', {
								"primaryType": this.info.primaryType,
								"secondary": this.info.secondary,
								"commodityId": this.info.commodityId,
								"state": this.info.state,
								"labelIds": labelIds
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('添加成功')
									this.getList()
									this.dialogVisible = false
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else {
							this.$http.post('/api/plant/knowledgeBase/updateCategoryStyle', {
								"primaryType": this.info.primaryType,
								"secondary": this.info.secondary,
								"commodityId": this.info.commodityId,
								"state": this.info.state,
								"labelIds": labelIds,
								"id": this.info.id
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('修改成功')
									this.getList()
									this.dialogVisible = false
								} else {
									this.$message.error(res.data.msg)
								}
							})
						}
					}
				});
			},
			editorCircle(row) {
				console.log(row);
				this.title = '修改品类款式'
				this.dialogVisible = true
				this.$http.get(`/api/product/productCategory/selectProductByCategoryId?categoryId=${row.secondary}`, {})
					.then(res => {
						if (res.data.data.length > 0) {
							this.options = []
							res.data.data.forEach(item => {
								this.options.push({
									label: item.name,
									value: item.id
								})
							})
						}
					})
				console.log(this.options);
				this.info = {
					arr: [row.primaryType, row.secondary],
					primaryType: row.primary,
					secondary: row.secondary,
					commodityId: row.commodityId,
					labelIds: row.labelIds,
					state: row.state,
					id: row.id
				}
			},
			delCircle(row) {
				console.log(row);
				this.$confirm('此操作将永久删除该品类, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/knowledgeBase/updateCategoryStyle', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.getList()
						} else {
							this.$message({
								type: 'info',
								message: '删除失败'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			viewCircle(row) {
				console.log(row);
				this.id = row.id
				this.$router.push({
					path: "./catStyleDet",
					query: {
						id: row.id
					},
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size;
				//重新请求数据
				this.getList();
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage;
				//重新请求数据
				this.getList();
			},
			//获取列表
			getList() {
				let primaryType = null
				let secondary = null
				console.log();
				console.log(JSON.stringify(this.$route.query) == {});
				if (Object.keys(this.$route.query).length != 0) {
					primaryType = this.$route.query.primaryType
					secondary = this.$route.query.secondary
				} else if (this.arr.length > 0) {
					primaryType = this.arr[0]
					secondary = this.arr[1]
				} else {
					primaryType = null
					secondary = null
				}
				console.log(primaryType, secondary);
				this.$http.post("/api/plant/knowledgeBase/selectCategoryStyle", {
					primaryType: primaryType, //一级品类编号
					secondary: secondary, //二级品类编号
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					commodityId: this.commodityId,
					commodityName: this.commodityName
				}).then((res) => {
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(i => {
							i.labelName = []
							i.labelIds = []
							if (i.labelVos) {
								i.labelVos.forEach(item => {
									i.labelName.push(item.labelName)
									i.labelIds.push([item.parentLabelId, item.labelId])
								})
							}
						})
					};
					console.log(res.data.data.list);
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
				})
			},
			//获取分类
			getpaiCategory() {
				this.$http.get("/api/plant/plantManage/productPaiCategoryDrop", {}).then((res) => {
					console.log('分类', res.data);
					this.options2 = res.data.data;
				});
			},
			//获取销售人群
			getinfo() {
				let arr = []
				this.$http.get("/api/plant/clrLabel/selectLabelList", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					console.log(res.data.data);
					res.data.data.forEach((item) => {
						item.sonList.forEach(i => {
							arr.push({
								id: i.memberLabelId,
								name: i.name,
								sonList: i.sonList
							})
						})
					});
					arr.forEach(item => {
						item.sonList2 = []
						item.sonList.forEach(item2 => {
							item.sonList2.push({
								id: item2.memberLabelId,
								name: item2.name
							})
						})
					})
					console.log(arr);
					this.options3 = arr
				});
			},
		},
		created() {
			this.getList();
			this.getpaiCategory();
			this.getinfo();
		},
	};
</script>

<style scoped>
</style>
